module.exports = __webpack_public_path__ + "img/05-涪江.161a4cde.jpg";